@import 'styles/mixins';
@import 'styles/variables';

.tracker {
  content: '';
  position: absolute;
  width: 2px;
  left: calc((var(--collab-item-toggle-padding) + (var(--collab-item-avatar-size) / 2)) - 1px);
  background-color: $grey-5;
}

.trackerBefore {
  &:before {
    @extend .tracker;
    top: 0;
    height: var(--collab-item-toggle-padding);
  }
}

.trackerAfter {
  &:after {
    @extend .tracker;
    top: calc(var(--collab-item-toggle-padding) + var(--collab-item-avatar-size));
    bottom: 0;
  }
}

.root {
  position: relative;
  padding: var(--collab-item-padding);
  border-radius: 4px;
  transition: none;

  &:first-child {
    @extend .trackerAfter;

    &:after {
      top: calc(var(--collab-item-padding) + var(--collab-item-avatar-size));
      left: calc((var(--collab-item-padding) + (var(--collab-item-avatar-size) / 2)) - 1px);
    }
  }

  &:last-child {
    @extend .trackerBefore;

    &:before {
      height: 0;
      left: calc((var(--collab-item-padding) + (var(--collab-item-avatar-size) / 2)) - 1px);
    }
  }

  &:first-child:last-child {
    &:before,
    &:after {
      display: none;
    }
  }

  &:not(:first-child):not(:last-child) {
    @extend .trackerBefore;
    @extend .trackerAfter;

    &:after {
      left: calc((var(--collab-item-padding) + (var(--collab-item-avatar-size) / 2)) - 1px);
      top: var(--collab-item-avatar-size);
    }
    &:before {
      left: calc((var(--collab-item-padding) + (var(--collab-item-avatar-size) / 2)) - 1px);
      height: 0;
    }
  }

  &.editing {
    z-index: 1;
    border-radius: 8px;
    padding: var(--collab-item-padding);
    box-shadow: none;

    &:before,
    &:after {
      display: none;
    }
  }

  &.highlighted {
    &:first-child,
    &:last-child,
    &:first-child:last-child,
    &:not(:first-child):not(:last-child) {
      &:before,
      &:after {
        background-color: var(--neutral-10);
      }
    }

    &.editing {
      background-color: var(--neutral-0);
    }
  }
}
